import { Logger } from "../utils/Logger";
import type { ControllerMap } from "./ControllerRegistry";

const PREFIX = "[inword]";

export type DispatchSource = "page" | "global";

/**
 * 레이아웃/전역에서 공통: 등록되지 않은 TS 컨트롤러·액션이면 console.warn.
 */
export function dispatchControllerWithWarn(
  registry: Record<string, ControllerMap>,
  controller: string,
  action: string,
  source: DispatchSource,
): void {
  const tag = source === "page" ? `${PREFIX} page` : `${PREFIX} global`;
  if (!controller || !action) {
    return;
  }
  const ctrl = registry[controller];
  if (!ctrl) {
    console.warn(
      `${tag}: no TS entry for controller "${controller}". (Add to controllerRegistry / routes/web.php class short name)`,
    );
    return;
  }
  const fn = (ctrl as Record<string, unknown>)[action];
  if (typeof fn !== "function") {
    console.warn(
      `${tag}: no TS method "${action}" on "${controller}". (PHP current_action and TS export name must match)`,
    );
    return;
  }
  try {
    (fn as () => void).call(ctrl);
  } catch (e) {
    Logger.error("dispatch: runtime error", controller, action, e);
  }
}
